import React, { useState, useEffect, useRef } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { Box, Card, CardContent, Typography, Button, CircularProgress } from '@mui/material';
import axios from 'axios';
import meestLogo from '../../assets/logoNew.svg';
import paymentsLogo from '../../assets/payments.png';
import SessionExpired from '../SessionExpired/SessionExpired';

const paymentTypes = {
  C: 'Післяплата за відправлення',
  D: 'Послуги',
  T: 'Митні послуги',
  P: 'Пакування відправлення'
};

const statusMessages = {
  need_pay: 'Очікуємо на оплату',
  need_3ds: 'Очікуємо на оплату',
  in_progress: 'Успішно, очікуємо підтвердження банку',
  success: 'Оплачено',
  rejected: 'Не вдалося реалізувати оплату',
  error: 'Не вдалося реалізувати оплату',
  canceled: 'Платіж відхилено банком',
};

const statusColors = {
  need_pay: '#FFBE0B',
  need_3ds: '#FFBE0B',
  in_progress: '#57C278',
  success: '#57C278',
  rejected: '#FE6975',
  error: '#FE6975',
  canceled: '#FE6975'
};
// TODO add some later, when backend will be ready
// const token = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJzdWIiOiJmcm9udC1idWlzbmVzLXRlc3QiLCJleHAiOjE3MzQxNzg0Mjh9.EbPIwg9oEPa0DZTYGCANIjRWDOHy3dXOr7eGu-S0P-w'; 

const Session = () => {
  const { sessionId, paymentNumber } = useParams();
  const navigate = useNavigate();
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(false);
  const [isClickable, setIsClickable] = useState(false);
  const [timeLeft, setTimeLeft] = useState(30);
  const [showRetryLink, setShowRetryLink] = useState(false);
  const [previousPayments, setPreviousPayments] = useState([]);
  const [allPaymentsSuccessful, setAllPaymentsSuccessful] = useState(false);
  const [sessionExpired, setSessionExpired] = useState(false);
  // const [sessionData, setSessionData] = useState(null);
  const [isRetryClickable, setIsRetryClickable] = useState(true);

  const previousPaymentsRef = useRef([]);

  useEffect(() => {
    if (paymentNumber) {
      getRedirect(paymentNumber)
    } else if (sessionId) {
      let interval;

      const fetchData = async () => {
        if (allPaymentsSuccessful) {
          return;
        }

        try {
          const response = await axios.get(
            `${process.env.REACT_APP_API_URL}/clients/v1/sessions/getter/session/${sessionId}`
          );

          let payments = response.data.payments;
          // Сортуємо масиви за полем 'index' (унікальне поле)
          payments = [...payments].sort((a, b) => a.index - b.index);
          const someHasInProgress = payments.some(payment => payment.status === 'in_progress');
          const paymentClicked = localStorage.getItem('paymentClicked');
          if (previousPaymentsRef.current.length === 0) {
            previousPaymentsRef.current = payments;
            setData(response.data);
            if (paymentClicked === 'true') {
              setLoading(true);
            } else if (someHasInProgress) {
              localStorage.setItem('paymentClicked', 'true');
              setLoading(true);
            } else {
              setLoading(false);

            }

            return;
          }
          const prevSorted = [...previousPaymentsRef.current].sort((a, b) => a.index - b.index);

          let statusChanged = false;
          if (payments.length === prevSorted.length) {
            statusChanged = payments.some((payment, i) => payment.status !== prevSorted[i].status);
          } else {
            statusChanged = true;
          }
          const allHasCanceled = payments.every(payment => payment.status === 'canceled');
          const someHasCanceled = payments.some(payment => payment.status === 'canceled');
          const allPaymentsSuccessfulNow = payments.every(payment => payment.status === 'success');

          if (allHasCanceled) {
            setData(response.data);
            setLoading(false);
            clearInterval(interval);
            setAllPaymentsSuccessful(false);
            localStorage.removeItem('paymentClicked');
            return;
          }

          if (someHasCanceled) {
            setData(response.data);
            setAllPaymentsSuccessful(false);
            setLoading(false);
            localStorage.removeItem('paymentClicked');

            return;
          }

          if (statusChanged || allPaymentsSuccessfulNow) {
            // Оновлюємо previousPaymentsRef, тільки якщо статус змінився або всі стали успішними
            previousPaymentsRef.current = payments;
            setData(response.data);
            setLoading(false);
            localStorage.removeItem('paymentClicked');
          }
          if (allPaymentsSuccessfulNow) {
            setAllPaymentsSuccessful(true);
            clearInterval(interval);
            localStorage.removeItem('paymentClicked');
          }

        } catch (error) {
          if (error.response) {
            const statusCode = error.response.status;
            if (statusCode === 404 && window.location.pathname === `/client/session/${sessionId}`) {
              setSessionExpired(true);
            } else {
              navigate('/notFound');
            }
          }
          console.error('Error fetching data:', error);
        }
      };

      fetchData();
      interval = setInterval(fetchData, 5000);

      return () => clearInterval(interval);
    }
  }, [paymentNumber, sessionId, navigate, allPaymentsSuccessful]);

  useEffect(() => {
    const paymentClicked = localStorage.getItem('paymentClicked');
    if (paymentClicked === 'true') {
      setShowRetryLink(true);
      setTimeLeft(60);
      setIsClickable(false);
      setLoading(true);

      const timerId = setInterval(() => {
        setTimeLeft((prevTime) => {
          if (prevTime <= 1) {
            clearInterval(timerId);
            setIsClickable(true);

            localStorage.removeItem('paymentClicked');
            return 0;
          }
          return prevTime - 1;
        });
      }, 1000);

      return () => clearInterval(timerId);
    }
  }, []);



  // useEffect(() => {
  //   if (sessionId) {

  //     let interval;

  //     const fetchData = async () => {
  //       if (allPaymentsSuccessful) {
  //         return;
  //       }

  //       try {
  //         const response = await axios.get(
  //           `${process.env.REACT_APP_API_URL}/clients/v1/sessions/getter/session/${sessionId}`
  //         );

  //         let payments = response.data.payments;
  //         // Сортуємо масиви за полем 'index' (унікальне поле)
  //         payments = [...payments].sort((a, b) => a.index - b.index);
  //         const someHasInProgress = payments.some(payment => payment.status === 'in_progress');
  //         const paymentClicked = localStorage.getItem('paymentClicked');
  //         if (previousPaymentsRef.current.length === 0) {
  //           previousPaymentsRef.current = payments;
  //           setData(response.data);
  //           if (paymentClicked === 'true') {
  //             setLoading(true);
  //           } else if (someHasInProgress) {
  //             localStorage.setItem('paymentClicked', 'true');
  //             setLoading(true);
  //           } else {
  //             setLoading(false);

  //           }

  //           return;
  //         }
  //         const prevSorted = [...previousPaymentsRef.current].sort((a, b) => a.index - b.index);

  //         let statusChanged = false;
  //         if (payments.length === prevSorted.length) {
  //           // Порівнюємо лише статуси поелементно
  //           statusChanged = payments.some((payment, i) => payment.status !== prevSorted[i].status);
  //         } else {
  //           // Якщо довжини не збігаються – дані змінились
  //           statusChanged = true;
  //         }
  //         const allHasCanceled = payments.every(payment => payment.status === 'canceled');
  //         const someHasCanceled = payments.some(payment => payment.status === 'canceled');
  //         const allPaymentsSuccessfulNow = payments.every(payment => payment.status === 'success');

  //         if (allHasCanceled) {
  //           setData(response.data);
  //           setLoading(false);
  //           clearInterval(interval);
  //           setAllPaymentsSuccessful(false);
  //           localStorage.removeItem('paymentClicked');
  //           return;
  //         }

  //         if (someHasCanceled) {
  //           setData(response.data);
  //           setAllPaymentsSuccessful(false);
  //           setLoading(false);
  //           localStorage.removeItem('paymentClicked');

  //           return;
  //         }

  //         if (statusChanged || allPaymentsSuccessfulNow) {
  //           // Оновлюємо previousPaymentsRef, тільки якщо статус змінився або всі стали успішними
  //           previousPaymentsRef.current = payments;
  //           setData(response.data);
  //           setLoading(false);
  //           localStorage.removeItem('paymentClicked');
  //         }
  //         if (allPaymentsSuccessfulNow) {
  //           setAllPaymentsSuccessful(true);
  //           clearInterval(interval);
  //           localStorage.removeItem('paymentClicked');
  //         }

  //       } catch (error) {
  //         if (error.response) {
  //           const statusCode = error.response.status;
  //           if (statusCode === 404 && window.location.pathname === `/client/session/${sessionId}`) {
  //             setSessionExpired(true);
  //           } else {
  //             navigate('/notFound');
  //           }
  //         }
  //         console.error('Error fetching data:', error);
  //       }
  //     };

  //     fetchData();
  //     interval = setInterval(fetchData, 5000);

  //     return () => clearInterval(interval);
  //   }
  // }, [sessionId, navigate, allPaymentsSuccessful]);


  if (sessionExpired) {
    return <SessionExpired />;
  }

  const getNewLink = async () => {
    setLoading(true);
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_API_URL}/clients/v1/sessions/payment/create`,
        {
          parcelNumber: data.parcel_number,
        },
        // TODO add some later, when backend will be ready
        // {
        //   headers: {
        //     Authorization: `Bearer ${token}`,
        //   },
        // }
      );
      setData(response.data);

      if (response.data) {
        const redirectLink = response.data.clientLink || response.data.link;
        if (redirectLink) {
          window.location.href = redirectLink;
        }
      }
    } catch (error) {
      if (error.response) {
        const statusCode = error.response.status;
        if (statusCode === 409) {
          const redirectLink = `${process.env.REACT_APP_API_URL}/${data.parcel_number}`
          window.location.href = redirectLink;
        }
      }

      console.log(error);
    } finally {
      setLoading(false);
    }
  };
  const getRedirect = async (paymentNumber) => {
    setLoading(true);
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_API_URL}/clients/v1/sessions/getter/session/id/${paymentNumber}
        `
      );
      if (response.data.session_id) {
        const redirectLink = `${process.env.REACT_APP_LINK_TO_SITE}/client/session/${response.data.session_id}`
        console.log(redirectLink, 'redirectLink');
        if (redirectLink) {
          window.location.href = redirectLink;
        }
      }
    } catch (error) {
      if (error.response) {
        const statusCode = error.response.status;
        if (statusCode === 404) {
          navigate('/notFound');
        }
      }
    } finally {
      setLoading(false);
    }
  };
  const redirectToMultiSession = (multisessionId) => {
    const redirectLink = `${process.env.REACT_APP_LINK_TO_SITE}/multi/${multisessionId}`
    if (redirectLink) {
      window.location.href = redirectLink;
    }
  };

  const handlePaymentClick = (link) => {
    localStorage.setItem('paymentClicked', 'true');

    setLoading(true);
    setShowRetryLink(true);
    setTimeLeft(60);
    setIsClickable(false);
    window.location.href = link;
    const timerId = setInterval(() => {
      setTimeLeft(prevTime => {
        if (prevTime === 1) {
          setIsClickable(true);
          clearInterval(timerId);
        }
        return prevTime - 1;
      });
    }, 1000);

  };

  const handleRetryClick = () => {
    if (!isRetryClickable) return;
    setIsRetryClickable(false);
    const needPayPayment = data?.payments.find(payment => payment.status === 'need_pay' && payment.link_to_pay);
    const need3dsPayment = data?.payments.find(payment => payment.status === 'need_3ds' && payment.link_to_pay);

    if (needPayPayment || need3dsPayment) {
      localStorage.removeItem('paymentClicked');
      getNewLink();
    }
    setTimeout(() => {
      setIsRetryClickable(true);
    }, 3000);
  };

  const renderPaymentStatus = (payment) => {
    if (payment.status === 'need_pay' && !payment.link_to_pay) {
      return (
        <Box display="flex" alignItems="center">
          <Typography variant="body2" color={statusColors[payment.status]} style={{ fontWeight: 'bold', marginRight: '5px', fontSize: '20px' }}>
            •
          </Typography>
          <Typography variant="body2" color="#FFBE0B">
            Наступний платіж
          </Typography>
        </Box>
      );
    }

    return (
      <Box display="flex" flexDirection="column">
        <Box display="flex" alignItems="center">
          <Typography variant="body2" color={statusColors[payment.status]} style={{ fontWeight: 'bold', marginRight: '5px', fontSize: '20px' }}>
            •
          </Typography>
          <Typography variant="body2" color={statusColors[payment.status]}>
            {statusMessages[payment.status]}
          </Typography>
        </Box>
        {(payment.status === 'need_3ds' && !payment.link_to_pay) && (
          <Typography variant="body2" color="red" mt={1}>
            Не вдалося реалізувати оплату
          </Typography>
        )}
      </Box>
    );
  };

  const getButtonProps = () => {
    const needPayPayment = data?.payments.find(payment => payment.status === 'need_pay' && payment.link_to_pay);
    const need3dsPayment = data?.payments.find(payment => payment.status === 'need_3ds' && payment.link_to_pay);
    const need3dsPaymentWithoutLinkPay = data?.payments.some(payment => payment.status === 'need_3ds' && !payment.link_to_pay);
    const rejectedOrCompletedPayment = data?.payments.find(payment => ['rejected', 'error', 'canceled', 'success'].includes(payment.status));

    if (data?.multisession_id && allPaymentsSuccessful) {
      return {
        text: 'Повернутись до списку відправлень',
        action: () => redirectToMultiSession(data.multisession_id),
      };
    }

    if (needPayPayment) {
      return {
        text: 'Оплатити',
        action: () => handlePaymentClick(needPayPayment.link_to_pay),
      };
    }

    if (need3dsPayment) {
      return {
        text: 'Оплатити',
        action: () => handlePaymentClick(need3dsPayment.link_to_pay),
      };
    }

    if (rejectedOrCompletedPayment || need3dsPaymentWithoutLinkPay) {
      // setLoading(false);
      return {
        text: '',
        action: null,
        showCompletionMessage: true,
      };
    }

    return {
      text: '',
      action: null,
      loading: true,
    };
  };

  const { text, action, loading: buttonLoading, showCompletionMessage } = getButtonProps();

  // const allHasCanceled = data.payments.every((payment) => payment.status === 'canceled');

  return (
    <>
      {
        data ? (
          <Box
            display="flex"
            justifyContent="center"
            alignItems="center"
            height="100vh"
            bgcolor="#f5f5f5"
          >
            <Box
              sx={{
                width: '460px',
                height: '150px',
                backgroundColor: '#005096',
                position: 'absolute',
                top: 0,
                display: {
                  xs: 'none',
                  sm: 'block',
                },
              }}
            />

            <Card style={{
              width: 420, height: '94%', flexDirection: 'column', justifyContent: 'space-between', borderRadius: '15px', padding: '20px', zIndex: '10', overflowY: 'scroll',
              WebkitOverflowScrolling: 'touch',
              scrollbarGutter: 'stable',
            }}
              sx={{
                '::-webkit-scrollbar': {
                  width: '6px',
                },
                '::-webkit-scrollbar-track': {
                  background: '#f1f1f1',
                },
                '::-webkit-scrollbar-thumb': {
                  background: '#888',
                  borderRadius: '4px',
                },
                '::-webkit-scrollbar-thumb:hover': {
                  background: '#555',
                },
              }}
            >
              <Box display="flex" justifyContent="center">
                <img src={meestLogo} alt="Meest Logo" style={{ height: '40px' }} />
              </Box>

              <CardContent style={{ flex: '1 0 auto' }}>
                <Box p={2} borderRadius={1} boxShadow="0px 4px 6px rgba(0, 0, 0, 0.1)" bgcolor="#FFFFFF">
                  <Typography variant="body1" color="textSecondary">
                    Номер відправлення:
                  </Typography>
                  <Typography variant="h7" color="textPrimary" gutterBottom style={{ fontWeight: 'bold' }}>
                    {data.parcel_number}
                  </Typography>
                </Box>

                <Box
                  sx={{
                    mt: { xs: 1, sm: 2 },
                    p: { xs: 1, sm: 2 },
                    borderRadius: 1,
                    boxShadow: "0px 4px 6px rgba(0, 0, 0, 0.1)",
                    bgcolor: "#FFFFFF",
                  }}>
                  <Typography variant="body1" color="textSecondary">
                    До оплати:
                  </Typography>

                  {data.payments.sort((a, b) => a.index - b.index).map(payment => (
                    <Box key={payment.payment_number} mt={1}>
                      <Box display="flex" justifyContent="space-between">
                        <Typography variant="body2" color="textPrimary">
                          {paymentTypes[payment.payment_type]}
                        </Typography>
                        <Typography variant="body2" color="textPrimary">
                          {payment.payment_summ ? `${payment.payment_summ} ₴` : payment.payment_summ}
                        </Typography>
                      </Box>
                      {payment.commission && parseFloat(payment.commission) > 0 && (
                        <Box display="flex" justifyContent="space-between">
                          <Typography variant="body2" color="textSecondary">
                            Комісія банку:
                          </Typography>
                          <Typography variant="body2" color="textPrimary">
                            {payment.commission} ₴
                          </Typography>
                        </Box>
                      )}
                      {renderPaymentStatus(payment)}
                    </Box>
                  ))}
                </Box>
                {!showCompletionMessage && !loading ? (
                  <Box
                    sx={{
                      mt: { xs: 1, sm: 2 },
                      p: { xs: 1, sm: 2 },
                      borderRadius: 1,
                      boxShadow: "0px 4px 6px rgba(0, 0, 0, 0.1)",
                      bgcolor: "#FFFFFF",
                    }}
                  >
                    <Typography variant="body1" color="textSecondary" gutterBottom>
                      Сплатити за допомогою сервісу:
                    </Typography>
                    <Box display="flex" justifyContent="center" alignItems="center" bgcolor="#F5F6F9" p={2}>
                      <img src={paymentsLogo} alt="Portmone" style={{ width: '80%', height: 'auto' }} />
                    </Box>
                  </Box>) : null}

                {loading ? (
                  <Box
                    sx={{
                      mt: { xs: 1, sm: 2 },
                      p: { xs: 1, sm: 2 },
                      borderRadius: 1,
                      boxShadow: "0px 4px 6px rgba(0, 0, 0, 0.1)",
                      bgcolor: "#FFFFFF",
                      '@media (max-height: 670px)': {
                        mt: 0,
                      }
                    }}
                  >
                    <Typography variant="body1" color="textSecondary" gutterBottom>
                      Сплатити за допомогою сервісу:
                    </Typography>
                    <Box display="flex" justifyContent="center" alignItems="center" bgcolor="#F5F6F9" p={2} borderRadius={2} flexDirection="column">
                      <CircularProgress style={{ color: '#3A7CFF', width: '40px', height: '40px' }} />
                      <Typography variant="body1" color="#0061AF" align="center" mt={2}>
                        Очікуємо результатів оплати
                      </Typography>
                    </Box>
                  </Box>
                ) : null}

              </CardContent>

              {data.payments.some(payment => payment.status === 'need_3ds' && payment.link_to_pay && !loading) && (
                <Box
                  sx={{
                    p: { xs: '0 16px', sm: '16px' },
                    borderRadius: 1,
                  }}
                >
                  Виконайте наступну оплату
                </Box>
              )}
              {data.payments.some(payment => payment.status === 'need_3ds' && !payment.link_to_pay) && (
                <Box
                  sx={{
                    p: { xs: '0 16px', sm: '16px' },
                    borderRadius: 1,
                  }}
                >
                  На жаль виник збій оплати в банку. Спробуйте пізніше
                </Box>
              )}

              <Box mt={2} pb={2} width="100%">
                {showRetryLink && timeLeft > 0 && !showCompletionMessage && loading ? (
                  <Typography
                    variant="body2"
                    color="textPrimary"
                    align="center"
                    mb={2}
                    style={{ cursor: 'not-allowed' }}
                  >
                    Не вдалося оплатити? Перейдіть по посиланню для повторної спроби через ({timeLeft} с.)
                  </Typography>
                ) :
                  isClickable && !showCompletionMessage && loading && isRetryClickable ? (
                    <Typography
                      variant="body2"
                      color="primary"
                      align="center"
                      mb={2}
                      onClick={handleRetryClick}
                      style={{ cursor: 'pointer' }}
                    >
                      <span style={{ color: '#0061AF', textDecoration: 'underline' }}>
                        Не вдалося оплатити? Перейдіть по посиланню для повторної спроби.
                      </span>
                    </Typography>
                  ) : null}

                {buttonLoading || loading ? (
                  <Button variant="contained" fullWidth sx={{ backgroundColor: '#0061AF', color: '#fff', height: '48px' }}>
                    <CircularProgress size={24} sx={{ color: '#fff' }} />
                  </Button>
                ) : data.payments.every((payment) => payment.status === 'canceled') ? (
                  <Typography variant="body2" color="textPrimary" align="center" mb={2}>
                    На жаль, виникла проблема оплати в банку або з Вашою картою. Спробуйте пізніше.
                  </Typography>
                ) : showCompletionMessage ? (
                  <Typography variant="body2" color="textPrimary" align="center">
                    Дії з оплатою на цій сторінці завершені. Поверніться до посилки і оновіть статус оплати.
                  </Typography>
                ) : (
                  <Button variant="contained" fullWidth sx={{ backgroundColor: '#0061AF', color: '#fff', height: '48px' }} onClick={action}>
                    {text}
                  </Button>
                )}
              </Box>

            </Card>
          </Box >
        ) : (
          null
        )
      }
    </>

  );
};

export default Session;